export const userNotificationPlaceholders = [
    {
        label: 'Имя гостя',
        value: '%USER_NAME%',
        defaultValue: 'Пользователь',
        exampleValue: 'Иван'
    }
];
